const getters = {
  claims: (state) => state.claims,
  processing: (state) => state.processing,
};

export default getters;
